import { Flex } from "@chakra-ui/react";

function TableHeaderRow() {
  return (
    <>
      <Flex flex={1}>
        <Flex pl="100px">Dados</Flex>
      </Flex>
      <Flex flex={1}>Contatos</Flex>
      <Flex flex={1}>Tipo</Flex>
      <Flex flex={1}>Endereço</Flex>
    </>
  );
}

export default TableHeaderRow;
